import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import FeatureSelector from './feature_selector';

const PackageForm = ({ open, onClose, onSave, packageData, features }) => {
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    price: '',
    note: '',
    badge: '',
    bestFor: '',
    features: [],
    displayOrder: 1,
    active: true,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (packageData) {
      setFormData({
        id: packageData.id,
        name: packageData.name,
        price: packageData.price,
        note: packageData.note || '',
        badge: packageData.badge || '',
        bestFor: packageData.bestFor || '',
        features: [...packageData.features],
        displayOrder: packageData.displayOrder || 1,
        active: packageData.active !== false,
      });
    } else {
      setFormData({
        id: '',
        name: '',
        price: '',
        note: '+ £12 Companies House Fee',
        badge: '',
        bestFor: '',
        features: [],
        displayOrder: 1,
        active: true,
      });
    }
  }, [packageData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.id.trim()) newErrors.id = 'Package ID is required';
    if (!formData.name.trim()) newErrors.name = 'Package name is required';
    if (!formData.price) newErrors.price = 'Price is required';
    if (isNaN(formData.price)) newErrors.price = 'Price must be a number';
    if (!formData.note.trim()) newErrors.note = 'Note is required';
    if (!formData.bestFor.trim()) newErrors.bestFor = 'Description is required';
    if (formData.features.length === 0)
      newErrors.features = 'At least one feature is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      const dataToSend = {
        ...formData,
        price: parseFloat(formData.price),
        // Send only feature IDs to backend
        features: formData.features.map((f) => f.id),
      };

      if (packageData) {
        // Replace with actual API call
        // await api.put(`/packages/${packageData.id}`, dataToSend);
      } else {
        // Replace with actual API call
        // await api.post('/packages', dataToSend);
      }

      onSave();
    } catch (error) {
      console.error('Error saving package:', error);
    }
  };
  console.log(formData);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">
            {packageData ? 'Edit Package' : 'Create New Package'}
          </Typography>
          <IconButton onClick={onClose}>
            <Close />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={1}>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Package ID"
              name="id"
              value={formData.id}
              onChange={handleChange}
              error={!!errors.id}
              helperText={errors.id}
              margin="normal"
              disabled={!!packageData}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Package Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Price"
              name="price"
              type="number"
              value={formData.price}
              onChange={handleChange}
              error={!!errors.price}
              helperText={errors.price}
              margin="normal"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">£</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Badge Text (optional)"
              name="badge"
              value={formData.badge}
              onChange={handleChange}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Additional Note"
              name="note"
              value={formData.note}
              onChange={handleChange}
              error={!!errors.note}
              helperText={errors.note}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Best For Description"
              name="bestFor"
              value={formData.bestFor}
              onChange={handleChange}
              error={!!errors.bestFor}
              helperText={errors.bestFor}
              margin="normal"
              multiline
              rows={2}
            />
            <Typography variant="h6" gutterBottom>
              Features
            </Typography>
            <FeatureSelector
              featureIds={formData.features}
              onChange={(updatedIds) =>
                setFormData({ ...formData, features: updatedIds })
              }
              error={!!errors.features}
              helperText={errors.features}
              features={features}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={formData.active}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      active: e.target.checked,
                    }))
                  }
                  name="active"
                  color="primary"
                />
              }
              label="Active"
              sx={{ mt: 2 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSubmit} variant="contained" color="primary">
          Save Package
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PackageForm;
